import { BotGraphsData, TradeGraphType } from "@shared/types";

export const TRADE_CARD_COLUMN_SPANS = [10, 7, 7];
/** New look: a wider progress column for the gauge with its PnL % and time. */
export const NEW_LOOK_TRADE_CARD_COLUMN_SPANS = [10, 5, 9];
/** New look: the phone trade row's columns (symbol, amount, progress). */
export const NEW_LOOK_TRADE_ROW_COLUMNS =
  "minmax(0, 1.3fr) minmax(0, 0.8fr) minmax(0, 1fr)";
export const NEW_LOOK_TRADES_LAYOUT_KEY = "new_look_trades";
export const NEW_LOOK_COMPACT_TABLE_CLASS = "nl-compact-table";
export const NEW_LOOK_PROGRESS_COLUMN_CLASS = "nl-progress";
export const NEW_LOOK_TRADES_TABLE_MIN_VIEWPORT = "767.98px";

export const TRADE_GRAPH_TYPE_TO_KEY: Record<
  TradeGraphType,
  keyof BotGraphsData
> = {
  [TradeGraphType.ACCUMULATING_PROFIT]: "accumulated_profit",
  [TradeGraphType.PROFIT_BY_DAY]: "profit_by_day",
};
